module.exports = __webpack_public_path__ + "static/img/Yls.0e71a04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Yls.jpg
// module id = Y1qG
// module chunks = 1